import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OperationType } from "common/constants/sm-constants";
import { InternshipModel } from "common/models/page-models/internship/internship/internship-data-model";
import { UnassignInternshipModel } from "common/models/page-models/Student Internship List/Unassign-Internship/unassign-internship-data.model";
import { UnassignInternshipMetaModel } from "common/models/page-models/Student Internship List/Unassign-Internship/unassign-internship-meta.model";
import { RouteEnvelope, WidgetModel } from "common/models/utility-models/base-model";
import { FormResolverService } from "common/resolvers/core-resolvers/form-resolver";
import { SystemService } from "common/services/core-services/system.service";
import { InternshipWidgetService } from "common/widget/internship/intership-form.widget.service";




@Injectable({
    providedIn: 'root'
})
export class InternshipResolver extends FormResolverService<InternshipModel> {
    constructor(protected ws: InternshipWidgetService, protected override router: Router, protected ss: SystemService) {
        super(ws, router, ss);

        // console.log('Internship Resolved Called')
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new WidgetModel();
        const metaModel = this.pageService.getMetaModel();
        transferData.formData = new UnassignInternshipModel();
        transferData.formMeta = new UnassignInternshipMetaModel().getMetaModel();
        widget.transferData = transferData;
        return widget;
    }
}
